import { ErrorBoundary } from 'shared-ui';

import { fetchUsers } from 'api/users/users';
import { QueryKeyEnum } from 'core/global.enum';
import { useQuery } from 'hooks/useQuery/useQuery';
import { useSavedPagination } from 'hooks/useSavedPagination/useSavedPagination';
import { QueryKeyLocalStorageEnum } from 'context/query/queryContext/QueryContext.enum';
import { useSelectedUser } from 'hooks/useSelectedUser/useSelectedUser';

import { UsersList } from './UsersList';
import { UsersListContainerProps } from './UsersList.types';

export const UsersListContainer = ({ usersTableSearchQuery }: UsersListContainerProps) => {
  const { page, rowsPerPage, setPage, setRowsPerPage, storedQueryWithoutPagination, setPaginationCount } =
    useSavedPagination({
      queryKey: QueryKeyLocalStorageEnum.USERS,
      resetPaginationDependencyArray: [usersTableSearchQuery],
    });
  const { selectedUser, setSelectedUser } = useSelectedUser();

  const { data: usersResponse, isLoading: isLoadingUsers } = useQuery(
    [QueryKeyEnum.USERS, storedQueryWithoutPagination, page, rowsPerPage, usersTableSearchQuery],
    fetchUsers,
    {
      args: {
        ...storedQueryWithoutPagination,
        limit: rowsPerPage,
        offset: rowsPerPage * page,
        query: usersTableSearchQuery,
      },
      onSuccess: (response) => {
        setPaginationCount(response.count);

        const updatedUser = response.data.find((user) => user.username === selectedUser?.username);

        if (updatedUser) {
          setSelectedUser(updatedUser);
        }
      },
    },
  );

  return (
    <ErrorBoundary>
      <UsersList
        users={usersResponse?.data || []}
        isLoadingUsers={isLoadingUsers}
        usersCount={usersResponse?.count || 0}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
      />
    </ErrorBoundary>
  );
};
